<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <div style="float: left">
            <el-button
              v-access:add
              icon="el-icon-plus"
              size="small"
              @click="add"
              :disabled="isloading"
              type="danger"
              >新增</el-button
            >
            <!-- <el-button 
            icon="el-icon-plus"
            size="small"
            @click="importUser"
            >导入</el-button> -->
          </div>
          <div style="float: right">
            <el-input
              style="width: 290px;margin-right: 10px;"
              v-model="searchKey"
              clearable
              :placeholder="placeholder"
            />
            <el-button
              size="small"
              icon="el-icon-search"
              type="danger"
              @click="search"
              >查询</el-button
            >
          </div>
        </el-row>
      </div>

      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
            prop="Nickname"
            label="名称 / 单位名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="MobileNo"
            label="手机号码"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="Email"
            label="邮箱"
            width="200"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column label="注册时间" align="center" width="140">
            <template slot-scope="scope">
              {{ (scope.row.CreateTime * 1000) | formatDate }}
            </template>
          </el-table-column>
          <el-table-column
            prop="MemberType"
            label="账号类型"
            :formatter="MemberType"
            width="90"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="AccountType"
            label="注册方式"
            align="center"
            :formatter="accountType"
            width="90"
          ></el-table-column>
          <!-- <el-table-column
            prop="Status"
            label="状态"
            align="center"
            :formatter="status"
            width="75"
          ></el-table-column> -->
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:modify
                @click="innerReset(scope.row)"
                type="text"
                size="mini"
                >重置密码</el-button
              >
              <el-button
                v-access:read
                @click="innerRead(scope.row)"
                type="text"
                size="mini"
                >详情</el-button
              >
              <el-button
                v-access:modify
                @click="innerEdit(scope.row)"
                type="text"
                size="mini"
                >编辑</el-button
              >
              <!-- <el-button
                v-access:modify
                v-if="isEnable(scope.row)"
                @click="updateStatus(scope.row)"
                type="text"
                size="mini"
                >启用</el-button
              >
              <el-button
                v-access:modify
                v-else
                @click="updateStatus(scope.row)"
                type="text"
                size="mini"
                >禁用</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModuleEdit
      v-if="formVisible"
      :dataForm="formData"
      :formTitle="formTitle"
      :isEdit="isEdit"
      @formCallBack="formCallBack"
    ></ModuleEdit>
    <ModuleQuery
      v-if="formVisibleQuery"
      :dataForm="formDataQuery"
      :formTitle="formTitleQuery"
      @formCallBack="formCallBack"
    >
    </ModuleQuery>
    <el-dialog
      title="导入"
      :visible.sync="dialogVisible"
      width="20%"
      :before-close="handleClose"
    >
      <div class="importTemplate">
        <el-form label-position="right" label-width="90px">
          <el-form-item label="导入模板：">
            <el-upload
              class="upload-demo"
              :action="action"
              :headers="headers"
              accept=".xlsx,.xls"
              :before-upload="onCheckFile"
              :on-success="onFileUpLoad"
            >
              <el-button size="small" type="danger" round>导 入</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import ModuleEdit from "@/modules/zjrc/pages/users/users/edit";
import ModuleQuery from "@/modules/zjrc/pages/users/users/query";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import api from "@/modules/zjrc/api";
import md5 from "js-md5";
import store from "@/store";

export default {
  name: "list",
  data() {
    return {
      dialogVisible: false,
      isloading: false,
      isDelete: false,
      listData: [],
      headerRow: "header-row",
      formVisible: false,
      formVisibleQuery: false,
      formTitle: "",
      formTitleQuery: "",
      formData: {},
      formDataQuery: {},
      total: 0,
      currentPage: 1,
      pageSize: 15,
      searchModel: { accountType: "", status: "" },
      placeholder: "名称 / 单位名称 / 手机号 ",
      searchKey: "",
      isEdit: true,
      isEditQuery: true,
      action: "/api/Users/Import",
      headers: {
        "OF-Authorization": store.getters.GetUserToken,
      },
    };
  },
  methods: {
    importUser() {
      this.dialogVisible = true;
    },
    handleClose() {
      const vm = this;
      vm.dialogVisible = false;
    },
    onCheckFile(file, status) {
      const vm = this;
      let size = file.size / 1024 / 1024;
      vm.isloading = true;
      if (size > 100) {
        this.$message({
          type: "error",
          message: "附件大小必须小于100M",
        });
        status(false);
        vm.isloading = false;
        return;
      }
    },
    onFileUpLoad(res) {
      let vm = this;
      if (res.Code === 0) {
        this.currentPage = 1;
        this.searchKey = "";
        vm.loadData();
        vm.$message({
          type: "success",
          message: "导入成功",
        });
        vm.dialogVisible = false;
      } else {
        vm.$message({
          type: "error",
          message: res.Message,
        });
      }
      vm.isloading = false;
    },
    //关键字搜索
    search() {
      const vm = this
      vm.currentPage = 1
      vm.loadData();
    },
    loadData() {
      this.isloading = true;
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        Status: this.searchModel.status,
        AccountType: this.searchModel.accountType,
        SearchKey: this.searchKey,
      };
      api.QueryUsers(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          this.listData = rep.data.Data.rows;
        }
        this.isloading = false;
      });
    },
    innerEdit(rowData) {
      this.isEdit = true;
      this.formTitle = "编辑用户信息";
      this.formData = Object.assign({}, rowData);
      this.formData.CreateTime = this.formData.CreateTime * 1000;
      this.formVisible = true;
    },
    add() {
      this.isEdit = true;
      this.formTitle = "新增用户信息";
      this.formData = {};
      this.formVisible = true;
    },
    innerRead(rowData) {
      this.formTitleQuery = "查看用户信息";
      this.formDataQuery = Object.assign({}, rowData);
      this.formVisibleQuery = true;
    },
    formCallBack(data) {
      this.formVisible = false;
      this.formVisibleQuery = false;
      if (data != null) {
        this.loadData();
      }
    },

    formCallBackQuery() {
      this.formVisibleQuery = false;
    },

    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    //账户状态
    status(rowData) {
      return rowData.Status == 0 ? "启用" : "禁用";
    },
    MemberType(rowData) {
      return rowData.MemberType == 1 ? "个人" : "团体";
    },
    //注册方式
    accountType(rowData) {
      return rowData.AccountType == 1 ? "PC" : "微信";
    },
    //更新状态
    updateStatus(rowData) {
      let warm =
        rowData.Status == 0
          ? "请确认是否禁用选中账号？"
          : "请确认是否启用选中账号？";
      this.$confirm(warm, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        rowData.Status = rowData.Status == 0 ? 1 : 0;
        let params = Object.assign({}, rowData);
        this.isloading = true;
        api
          .UpdateUser(params)
          .then((rep) => {
            if (rep.data.Code === 0) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
            } else {
              this.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
            this.isloading = false;
          })
          .catch((e) => {
            this.$message({
              message: e.toString(),
              type: "error",
            });
            this.isloading = false;
          });
      });
    },
    //重置密码
    innerReset(rowData) {
      this.$confirm("请确认是否重置选中账号的密码？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id, Password: md5("123456") };
        api
          .ResetUserPassword(params)
          .then((res) => {
            if (res.data.Code === 0) {
              this.$message({
                message: "密码已重置为：123456",
                type: "success",
              });
            } else {
              this.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
          })
          .catch((e) => {
            this.isConfirm = false;
            this.$message({
              message: e.toString(),
              type: "error",
            });
          });
      });
    },
    //删除
    innerDeleted(rowData) {
      this.$confirm("请确认是否删除选中的账号？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id };
        api
          .DeleteUser(params)
          .then((rep) => {
            if (rep.data.Code === 0) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.currentPage = 1;
              this.loadData();
            } else {
              this.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
          })
          .catch((e) => {
            this.$message({
              message: e.toString(),
              type: "error",
            });
          });
      });
    },
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModuleEdit,
    ModuleQuery,
  },
  mounted() {
    this.loadData();
  },
  computed: {
    isEnable: function () {
      return (rowData) => {
        return rowData.Status == 0 ? false : true;
      };
    },
  },
};
</script>

<style scoped lang="scss">
.el-select >>> .el-input__inner {
  width: 2.5rem;
}
.upload-demo {
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
  line-height: 30.6px;

  /deep/ .el-upload__input {
    display: none;
  }

  /deep/.el-upload-list {
    display: none;
  }
}
</style>
